// =============================================================================
// src/features/analytics/analytics-navigation-data.ts - Navegacao interna.
// =============================================================================

import type { OmarAnalyticsModuleEntry, OmarAnalyticsPeriod } from './analytics-types';

export const OMAR_ANALYTICS_MODULES: readonly OmarAnalyticsModuleEntry[] = [
  { moduleName: 'mentions', iconName: 'ti-target-arrow', label: 'Mencoes', groupName: 'monitoring' },
  { moduleName: 'destaques', iconName: 'ti-flame', label: 'Destaques', groupName: 'monitoring' },
  { moduleName: 'analysis', iconName: 'ti-chart-bar', label: 'Analises', groupName: 'monitoring' },
  { moduleName: 'digest', iconName: 'ti-sparkles', label: 'Resumo de IA', groupName: 'monitoring' },
  { moduleName: 'influencers', iconName: 'ti-user-star', label: 'Influenciadores', groupName: 'monitoring' },
  { moduleName: 'sites', iconName: 'ti-world-search', label: 'Sites', groupName: 'monitoring' },
  { moduleName: 'settings', iconName: 'ti-settings', label: 'Configuracoes', groupName: 'monitoring' },
  { moduleName: 'reports', iconName: 'ti-file-analytics', label: 'Relatorios', groupName: 'output' },
  { moduleName: 'emails', iconName: 'ti-bell-ringing', label: 'E-mails e alertas', groupName: 'output' },
  { moduleName: 'assistant', iconName: 'ti-message-chatbot', label: 'Assistente IA', groupName: 'intelligence' },
  { moduleName: 'comparison', iconName: 'ti-columns-3', label: 'Comparacao', groupName: 'intelligence' },
  { moduleName: 'team', iconName: 'ti-users-group', label: 'Membros da equipe', groupName: 'intelligence' },
];

export const OMAR_ANALYTICS_PERIOD_LABELS: Record<OmarAnalyticsPeriod, string> = {
  last7: 'Ultimos 7 dias',
  last30: 'Ultimos 30 dias',
};
